import AdPlacements from "@Networks/Localhost/Config/ad_placements";
import Network from '@Networks/Localhost';

class AdsManager
{
    /*--------- Rewarded Video -------------*/
    private rewardedVideo: Networks.AdInstance;
    private rewardedVideoLoaded: boolean;

    /*---------- Interstitals --------------*/
    private interstitial: Networks.AdInstance;
    private interstitialLoaded: boolean;

    /*------------ Timestamps ---------------*/
    private lastRewardedVideoShowTs: number;
    private lastInterstitialShowTs: number;

    constructor()
    {
        this.rewardedVideo = null;
        this.rewardedVideoLoaded = false;

        this.interstitial = null;
        this.interstitialLoaded = false;

        this.lastRewardedVideoShowTs = 0;
        this.lastInterstitialShowTs = 0;
    }

    /**
     * Gets rewarded video
     */
    public async getRewardedVideo()
    {
        const placementID = this.getPlacementID('rewarded_video');

        const rewardedVideo = await Network.getRewardedVideoAsync(placementID);

        this.rewardedVideo = rewardedVideo;
    }

    /**
     * Loads rewarded video
     */
    public async loadRewardedVideo()
    {
        if (this.rewardedVideo === null)
        {
            await this.getRewardedVideo();
        }

        await this.rewardedVideo.loadAsync();

        this.rewardedVideoLoaded = true;
    }

    /**
     * Gets interstitial video
     */
    public async getInterstitialVideo()
    {
        const placementID = this.getPlacementID('interstitial');

        const interstitial = await Network.getInterstitialAdAsync(placementID);

        this.interstitial = interstitial;
    }

    /**
     * Load intersitital
     */
    public async loadInterstitialVideo()
    {
        if (this.interstitial === null)
        {
            await this.getInterstitialVideo();
        }

        await this.interstitial.loadAsync();

        this.interstitialLoaded = true;
    }

    /**
     * Shows interstitial video
     */
    public async showInterstitialVideo()
    {
        if (!this.interstitialLoaded)
        {
            await this.loadInterstitialVideo();
        }

        await this.interstitial.showAsync();

        this.lastInterstitialShowTs = Date.now();

        this.interstitialLoaded = false;

        this.interstitial = null;
    }

    /**
     * Shows rewarded video
     */
    public async showRewardedVideo()
    {
        if (!this.rewardedVideoLoaded)
        {
            await this.loadRewardedVideo();
        }

        await this.rewardedVideo.showAsync();

        this.lastRewardedVideoShowTs = Date.now();

        this.rewardedVideoLoaded = false;

        this.rewardedVideo = null;
    }

    /**
     * Gets a placement key
     * @param type
     */
    private getPlacementID(type: string): string
    {
        const adPlacementKey = type.toUpperCase();

        if (AdPlacements.hasOwnProperty(adPlacementKey) === false)
        {
            throw new Error(`Placement key ${adPlacementKey} not found`);
        }

        return AdPlacements[adPlacementKey];
    }

    /**
     * Checks to see if rewarded video is loaded
     */
    public isRewardedVideoLoaded()
    {
        return this.rewardedVideo !== null;
    }

    /**
     * Checks to see if interstitial is loaded
     */
    public isInterstitialLoaded()
    {
        return this.interstitial !== null;
    }

    /**
     * Checks if network has interstitial support
     */
    public hasInterstitialSupport()
    {
        return Network.getSupportedAPIs().indexOf('getInterstitialAdAsync') !== -1
    }

    /**
     * Checks if rewarded video has interstitial support
     */
    public hasRewardedVideoSupport()
    {
        return Network.getSupportedAPIs().indexOf('getRewardedVideoAsync') !== -1
    }

    /**
     * Returns time since last rewarded video play
     */
    public getTimeSinceLastRewardedVideo()
    {
        return Date.now() - this.lastRewardedVideoShowTs;
    }

    /**
     * Returns time since last interstitial
     */
    public getTimeSinceLastInterstitial()
    {
        return Date.now() - this.lastInterstitialShowTs;
    }

}


export default AdsManager;